// this method sets JST on global namespace
// it's dangerous but needed for backwards compatibility

export const defineTemplate = (name) => {
  window.JST = window.JST || {};

  return window.JST[name] = require(`./../../${name}.jst.ejs`);
};



// WEBPACK FOOTER //
// ./webpack/templates/define_template.js